import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

interface Props {
  templateText: string
}

const TemplateTitle: FC<Props> = ({templateText}) => (
  <H4 color="white" textAlign="center" margin={[1, 0]}>
    <FormattedMessage id={templateText} />
  </H4>
)

export default TemplateTitle
